import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import styles from "./ProfileNavigation.module.css";
import { usePopupContext } from "../Login/PopupContext";
import PopUp from "../Login/PopUp";

const ProfileNavigation = () => {
  const { direction } = useContext(LanguageContext);
  const location = useLocation();
  const { popupData, setPopupValues } = usePopupContext();
  const [isErrorComponentVisible, setIsErrorComponentVisible] =
    React.useState(false);

  return (
    <nav style={{ position: "relative" }}>
      {isErrorComponentVisible && (
        <div
          style={{
            position: "fixed",
            zIndex: "1000",
            top: "0px",
            left: "0px",
            width: "100%",
            margin: "auto",
          }}
        >
          <PopUp
            titleEN={popupData.titleEN}
            titleAR={popupData.titleAR}
            descriptionEN={popupData.descriptionEN}
            descriptionAR={popupData.descriptionAR}
            buttonText1EN={popupData.buttonText1EN}
            buttonText1AR={popupData.buttonText1AR}
            buttonText2EN={popupData.buttonText2EN}
            buttonText2AR={popupData.buttonText2AR}
            linkText1EN={popupData.linkText1EN}
            linkText1AR={popupData.linkText1AR}
            linkText2EN={popupData.linkText2EN}
            linkText2AR={popupData.linkText2AR}
            button1Link={popupData.button1Link}
            button2Link={popupData.button2Link}
          />
        </div>
      )}
      <ul className={styles.profileTabs}>
        <li
          className={
            location.pathname === "/home/personalInformation"
              ? styles.activeTab
              : ""
          }
        >
          <Link
            to={
              localStorage.getItem("courseCount") > 0
                ? "/home/personalInformation"
                : "#"
            }
            onClick={(e) => {
              if (localStorage.getItem("courseCount") == 0) {
                e.preventDefault();
                setIsErrorComponentVisible(true);
                setPopupValues("canteditProfile");
              }
            }}
          >
            {direction === "rtl" ? "ملفي الشخصي" : "My Profile"}
          </Link>
        </li>
        <li
          className={
            location.pathname === "/home/Mycertificate" ? styles.activeTab : ""
          }
        >
          <Link
            to={
              localStorage.getItem("courseCount") > 0
                ? "/home/Mycertificate"
                : "#"
            }
            onClick={(e) => {
              if (localStorage.getItem("courseCount") == 0) {
                e.preventDefault();
                setIsErrorComponentVisible(true);
                setPopupValues("NotASubscriber");
              }
            }}
          >
            {direction === "rtl" ? "شهاداتي" : "My Certificates"}
          </Link>
        </li>
        <li
          className={
            location.pathname === "/home/wishlist" ? styles.activeTab : ""
          }
        >
          <Link to="/home/wishlist">
            {direction === "rtl" ? "قائمة رغباتي" : "My Wishlist"}
          </Link>
        </li>
        <li
          className={
            location.pathname === "/home/transaction" ? styles.activeTab : ""
          }
        >
          <Link
            to={
              localStorage.getItem("courseCount") > 0
                ? "/home/transaction"
                : "#"
            }
            onClick={(e) => {
              if (localStorage.getItem("courseCount") == 0) {
                e.preventDefault();
                setIsErrorComponentVisible(true);
                setPopupValues("NotASubscriber");
              }
            }}
          >
            {direction === "rtl" ? "معاملاتي" : "My Transactions"}
          </Link>
        </li>
      </ul>
      <hr className={styles.footerHr} />
    </nav>
  );
};

export default ProfileNavigation;
